/**
 * Utilidades para URLs de servicios externos
 * Centraliza las URLs para facilitar el mantenimiento y la configuración
 */

/**
 * Genera URL de avatar usando Dicebear
 * @param {string} seed - Semilla para generar el avatar
 * @returns {string} - URL del avatar
 */
export const getAvatarUrl = (seed = 'default') => {
  const baseUrl = process.env.REACT_APP_DICEBEAR_API_URL || 'https://api.dicebear.com/7.x/lorelei/svg';
  return `${baseUrl}?seed=${encodeURIComponent(seed)}`;
};

/**
 * Genera URL de imagen de Unsplash
 * @param {string} photoId - ID de la foto
 * @param {Object} options - Opciones de la imagen
 * @returns {string} - URL de la imagen
 */
export const getUnsplashImageUrl = (photoId, options = {}) => {
  const baseUrl = process.env.REACT_APP_UNSPLASH_API_URL || 'https://images.unsplash.com';
  const { width = 150, height = 150, fit = 'crop', crop = 'face' } = options;
  
  return `${baseUrl}/photo-${photoId}?w=${width}&h=${height}&fit=${fit}&crop=${crop}`;
};

/**
 * Valida si una URL es segura
 * @param {string} url - URL a validar
 * @returns {boolean} - Si la URL es segura
 */
export const isSecureUrl = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'https:' || urlObj.protocol === 'http:';
  } catch {
    return false;
  }
};

/**
 * Sanitiza una URL externa
 * @param {string} url - URL a sanitizar
 * @returns {string} - URL sanitizada
 */
export const sanitizeExternalUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }
  
  // Solo permitir URLs HTTPS en producción
  if (process.env.NODE_ENV === 'production' && !url.startsWith('https://')) {
    return '';
  }
  
  return url;
};